export default {
  methods: {
    getValue(obj, path) {
      if (!obj || !path) return undefined;
      return path.split('.').reduce((result, key) => (result ? result[key] : undefined), obj);
    },
    getCustomFieldConfig(key) {
      return this.bookingField && this.bookingField.custom ? this.bookingField.custom[key] : null;
    },
    getFieldLabel(key, config) {
      const map = {
        native_first_name: '本地名',
        native_last_name: '本地姓',
        english_first_name: '英文名',
        english_last_name: '英文姓',
        birth: '出生日期',
        passport_no: '护照号码',
        passport_expdate: '护照有效期',
        nationality: '国籍',
        id_no: '身份证号',
        mtp_no: 'MTP 号码',
        gender: '性别',
        tel_country_code: '区号',
        tel_number: '联系电话',
        has_app: '是否有通讯软件',
        contact_app: '通讯软件',
        contact_app_account: '通讯账号',
        country_cities: '国家/城市',
        zipcode: '邮编',
        address: '详细地址',
        hotel_name: '酒店名称',
        hotel_tel_number: '酒店电话',
        booking_website: '预订网站',
        booking_order_no: '预订单号',
        check_in_date: '入住日期',
        check_out_date: '退房日期',
        height: '身高',
        height_unit: '身高单位',
        weight: '体重',
        weight_unit: '体重单位',
        shoe_type: '鞋型',
        shoe: '鞋码',
        shoe_unit: '鞋码单位',
        glass_degree: '眼镜度数',
        meal: '餐食偏好',
        mobile_model_no: '设备型号',
        IMEI: 'IMEI 号码',
        active_date: '激活日期',
        s_date: '开始日期',
        e_date: '结束日期',
        s_time: '开始时间',
        e_time: '结束时间',
        s_location: '出发地点',
        e_location: '结束地点',
        departure_airport: '出发机场',
        arrival_airport: '到达机场',
        departure_terminalNo: '出发航站楼',
        arrival_terminalNo: '到达航站楼',
        departure_airlineName: '出发航空公司',
        arrival_airlineName: '到达航空公司',
        departure_flightNo: '出发航班号',
        arrival_flightNo: '到达航班号',
        departure_date: '出发日期',
        arrival_date: '到达日期',
        departure_time: '出发时间',
        arrival_time: '到达时间',
        departure_flightType: '出发航班类型',
        arrival_flightType: '到达航班类型',
      };
      return config && (config.title || config.name || config.desc)
        ? config.title || config.name || config.desc
        : (map[key] || key);
    },
    getFieldMode(config, key) {
      if (key === 'country_cities') return 'country_cities';
      if (key === 'address' || key === 'order_note') return 'textarea';
      if (this.getFieldOptions(config, key).length) return 'select';
      if (config && config.type === 'date') return 'date';
      if (config && config.type === 'time') return 'time';
      if (config && config.type === 'boolean') return 'boolean';
      if (config && typeof config.type === 'string' && ['int', 'integer', 'number'].indexOf(config.type.toLowerCase()) !== -1) {
        return 'number';
      }
      if (key === 'height' || key === 'weight') return 'number';
      return 'text';
    },
    getFieldOptions(config, key) {
      if (!config) return [];
      if (Array.isArray(config.list_option) && config.list_option.length) return config.list_option;
      if (Array.isArray(config.location) && config.location.length) return config.location;
      if (Array.isArray(config.location_list) && config.location_list.length) return config.location_list;
      if (key === 'tel_country_code' || key === 'buyer_tel_country_code') {
        return this.countryAreas.map((item) => ({
          id: item.tel_area,
          code: item.tel_area,
          name: '+' + item.tel_area + ' ' + item.country_name,
        }));
      }
      return [];
    },
    getTrafficFieldOptions(traffic, key, config) {
      if (!traffic) return this.getFieldOptions(config, key);
      if (key === 's_time' || key === 'e_time') {
        const dynamic = this.getTrafficTimeOptions(traffic, key);
        if (dynamic.length) return dynamic;
      }
      return this.getFieldOptions(config, key);
    },
    hasTrafficTimeOptions(traffic, key) {
      return this.getTrafficTimeOptions(traffic, key).length > 0;
    },
    getTrafficTimeOptions(traffic, key) {
      if (!traffic || (key !== 's_time' && key !== 'e_time')) return [];
      const trafficType = traffic.traffic_type;
      if (trafficType === 'rentcar_01' || trafficType === 'rentcar_02') {
        return this.getRentcarTimeOptions(traffic, key);
      }
      if (trafficType === 'pickup_04' && key === 's_time') {
        return this.getPickup04TimeOptions(traffic);
      }
      const config = this.getTrafficConfig(trafficType);
      const fieldConfig = config && config[key];
      return this.getFieldOptions(fieldConfig, key);
    },
    getPickup04TimeOptions(traffic) {
      const config = this.getTrafficConfig('pickup_04');
      const fieldConfig = config && config.s_time;
      const options = this.getFieldOptions(fieldConfig, 's_time');
      const presetOptions = options
        .filter((item) => !(item && item.time_range && item.time_range !== '~'))
        .map((item) => ({
          id: this.getOptionValue(item),
          code: this.getOptionValue(item),
          name: this.getPickup04OptionLabel(item),
        }));
      const customOptions = this.getTrafficCustomTimeOptions(traffic, 's_time');
      if (!customOptions.length) return presetOptions;
      const result = presetOptions.slice();
      const currentValue = traffic && traffic.s_time ? String(traffic.s_time) : '';
      const isCurrentCustom = currentValue && !presetOptions.some((item) => String(item.id) === currentValue);
      if (isCurrentCustom) {
        result.push({ id: currentValue, code: currentValue, name: `自定义时间 ${currentValue}` });
      }
      result.push({ id: 'customize', code: 'customize', name: '自定义时间' });
      return result;
    },
    getPickup04OptionLabel(item) {
      if (!item) return '';
      if (typeof item.hour !== 'undefined') {
        const hour = String(item.hour).padStart(2, '0');
        const minute = String(item.min != null ? item.min : 0).padStart(2, '0');
        return `${hour}:${minute}`;
      }
      return this.getOptionLabel(item);
    },
    getRentcarTimeOptions(traffic, key) {
      const trafficType = traffic && traffic.traffic_type;
      const config = this.getTrafficConfig(trafficType);
      if (!config) return [];
      const refPath = key === 'e_time' ? 'e_location' : 's_location';
      const selectedLocation = traffic[refPath];
      const locationField = config[refPath];
      const locationOptions = this.getFieldOptions(locationField, refPath);
      if (!selectedLocation || !locationOptions.length) return [];
      const selectedOption = locationOptions.find((item) => String(this.getOptionValue(item)) === String(selectedLocation));
      if (!selectedOption || !selectedOption.time_range || selectedOption.time_range === '~') return [];
      return this.buildTimeOptionsFromRange(selectedOption.time_range, 30);
    },
    buildTimeOptionsFromRange(timeRange, intervalMinutes) {
      if (!timeRange || typeof timeRange !== 'string') return [];
      const parts = timeRange.split('~');
      if (parts.length !== 2) return [];
      const start = this.parseTimeToMinutes(parts[0]);
      const end = this.parseTimeToMinutes(parts[1]);
      if (start === null || end === null || start > end) return [];
      const options = [];
      for (let current = start; current <= end; current += intervalMinutes) {
        const timeValue = this.formatMinutesToTime(current);
        options.push({ id: timeValue, code: timeValue, name: timeValue });
      }
      return options;
    },
    parseTimeToMinutes(value) {
      if (!value || typeof value !== 'string') return null;
      const parts = value.split(':');
      if (parts.length < 2) return null;
      const hour = Number(parts[0]);
      const minute = Number(parts[1]);
      if (Number.isNaN(hour) || Number.isNaN(minute)) return null;
      return hour * 60 + minute;
    },
    formatMinutesToTime(totalMinutes) {
      const hour = Math.floor(totalMinutes / 60);
      const minute = totalMinutes % 60;
      return String(hour).padStart(2, '0') + ':' + String(minute).padStart(2, '0');
    },
    getOptionLabel(item) {
      if (!item) return '';
      return item.name || item.label || item.title || item.app_name || item.meal_type_name || item.info || item.code || item.id || '';
    },
    getOptionValue(item) {
      if (!item) return '';
      return item.id || item.code || item.value || item.name || '';
    },
    isWideField(key) {
      return ['address', 'order_note', 'country_cities'].indexOf(key) !== -1;
    },
    isContactPhoneField(customer, key) {
      return customer && customer.cus_type === 'contact' && key === 'tel_number';
    },
    isContactAppField(customer, key) {
      return customer && customer.cus_type === 'contact' && key === 'contact_app';
    },
    shouldSkipSupportField(customer, key) {
      return customer
        && customer.cus_type === 'contact'
        && ['contact_app_account', 'tel_country_code', 'has_app'].indexOf(key) !== -1;
    },
    getCountryParent(customer, index) {
      return this.countryParentMap[String(index)] || '';
    },
    getCustomerIndex(customer) {
      return this.booking.custom.indexOf(customer);
    },
    setCountryParent(customer, index, value) {
      this.$set(this.countryParentMap, String(index), value);
      customer.country_cities = '';
    },
    getCountryCities(customer, index, config) {
      const parent = this.getCountryParent(customer, index);
      const country = (this.getFieldOptions(config, 'country_cities') || []).find((item) => String(item.id) === String(parent));
      if (!country || !country.cities) return [];
      return country.cities.map((city) => ({
        name: city.name,
        city_code: String(country.id) + '_' + city.city_code,
      }));
    },
    getContactPhoneEnabled(customer) {
      const index = this.getCustomerIndex(customer);
      return this.contactPhoneEnabledMap[String(index)] !== false;
    },
    setContactPhoneEnabled(customer, enabled) {
      const index = this.getCustomerIndex(customer);
      this.$set(this.contactPhoneEnabledMap, String(index), enabled);
      if (!enabled) {
        this.$set(customer, 'tel_country_code', '');
        this.$set(customer, 'tel_number', '');
      } else if (!customer.tel_country_code) {
        this.$set(customer, 'tel_country_code', '86');
      }
    },
    getContactAppEnabled(customer) {
      const index = this.getCustomerIndex(customer);
      return this.contactAppEnabledMap[String(index)] !== false;
    },
    setContactAppEnabled(customer, enabled) {
      const index = this.getCustomerIndex(customer);
      this.$set(this.contactAppEnabledMap, String(index), enabled);
      this.$set(customer, 'has_app', enabled);
      if (!enabled) {
        this.$set(customer, 'contact_app', '');
        this.$set(customer, 'contact_app_account', '');
      }
    },
    getSupportedContactApps() {
      const options = this.getFieldOptions(this.getCustomFieldConfig('contact_app'), 'contact_app');
      return options.filter((item) => item && item.supported !== false && item.supported !== 'false');
    },
    getContactAppOptionValue(item) {
      if (!item) return '';
      return item.app_type || this.getOptionValue(item);
    },
    getCustomerTitle(customer, index, type) {
      if (customer.cus_type === 'cus_01') return '旅客代表';
      if (customer.cus_type === 'cus_02') {
        const total = this.travelerCustomers.filter((item) => item.cus_type === 'cus_02').length;
        return total <= 1 ? '主旅客' : '旅客 ' + (index + 1);
      }
      const map = {
        contact: '旅游期间联系方式',
        send: '寄送资料',
      };
      return map[customer.cus_type] || (type === 'support' ? '补充信息' : '旅客信息');
    },
    getTrafficTitle(trafficType, index) {
      const map = {
        Flight: '航班信息',
        flight: '航班信息',
        rentcar_01: '租车服务',
        rentcar_02: '租车服务',
        rentcar_03: '租车服务',
        pickup_01: '接送信息',
        pickup_02: '接送信息',
        pickup_03: '接送信息',
        pickup_04: '接送信息',
        voucher: '兑换信息',
        psg_qty: '人数配置',
      };
      return map[trafficType] || ('服务信息 ' + (index + 1));
    },
    onTrafficFieldChange(traffic, key) {
      if (!traffic) return;
      if (traffic.traffic_type === 'rentcar_01' || traffic.traffic_type === 'rentcar_02') {
        if (key === 's_location') this.$set(traffic, 's_time', '');
        if (key === 'e_location') this.$set(traffic, 'e_time', '');
      }
      if (traffic.traffic_type === 'pickup_04' && key === 's_time' && traffic.s_time === 'customize') {
        const customOptions = this.getTrafficCustomTimeOptions(traffic, key);
        if (customOptions.length) {
          const generatedOptions = this.buildTimeOptionsFromRange(customOptions[0].time_range, 1);
          if (generatedOptions.length) {
            this.$set(traffic, 's_time', this.getOptionValue(generatedOptions[0]));
          }
        }
      }
    },
    getTrafficCustomTimeOptions(traffic, key) {
      if (!traffic || traffic.traffic_type !== 'pickup_04' || key !== 's_time') return [];
      const config = this.getTrafficConfig('pickup_04');
      const fieldConfig = config && config.s_time;
      const options = this.getFieldOptions(fieldConfig, 's_time');
      return options.filter((item) => item && item.time_range && item.time_range !== '~');
    },
    getSelectedVoucherLocation(traffic) {
      if (!traffic || traffic.traffic_type !== 'voucher' || !traffic.s_location) return null;
      const config = this.getTrafficConfig('voucher');
      const field = config && config.s_location;
      const locations = this.getFieldOptions(field, 's_location');
      return locations.find((item) => String(this.getOptionValue(item)) === String(traffic.s_location)) || null;
    },
    getVoucherLocationTimeLines(location) {
      if (!location || !Array.isArray(location.time_list) || !location.time_list.length) {
        return ['暂无营业时间信息'];
      }
      return location.time_list.map((item) => {
        const fromHour = item && item.from ? item.from.hour : '';
        const fromMinute = item && item.from && item.from.minute != null ? item.from.minute : 0;
        const toHour = item && item.to ? item.to.hour : '';
        const toMinute = item && item.to && item.to.minute != null ? item.to.minute : 0;
        const weekday = this.getLocationWeekday(item && item.weekDays ? item.weekDays : '');
        return `${fromHour}:${String(fromMinute).padStart(2, '0')}~${toHour}:${String(toMinute).padStart(2, '0')}${weekday ? ` ${weekday}` : ''}`;
      });
    },
    getLocationWeekday(week) {
      const weekday = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
      const normalized = typeof week === 'string' ? week.replace(/,/g, '') : '';
      const idx = normalized.indexOf('Y');
      return idx !== -1 ? weekday[idx] : '';
    },
    validateEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    },
    isEmptyValue(value) {
      return value === '' || value === null || typeof value === 'undefined';
    },
    shouldValidateCustomerField(customer, key) {
      if (!customer) return true;
      if (customer.cus_type === 'contact') {
        if (key === 'tel_number' || key === 'tel_country_code') {
          return this.getContactPhoneEnabled(customer);
        }
        if (key === 'contact_app' || key === 'contact_app_account') {
          return this.getContactAppEnabled(customer);
        }
      }
      return true;
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/shop/mixins/shopOrderFormMixin.js